/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Cancel1Inputs */

const zh_adminsubs_cancel1 = /** @type {(inputs: Adminsubs_Cancel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅`)
};

const en_adminsubs_cancel1 = /** @type {(inputs: Adminsubs_Cancel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_adminsubs_cancel1 = /** @type {(inputs: Adminsubs_Cancel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Adminsubs_Cancel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_cancel1 = /** @type {((inputs?: Adminsubs_Cancel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Cancel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_cancel1(inputs)
	if (locale === "en") return en_adminsubs_cancel1(inputs)
	return es_adminsubs_cancel1(inputs)
});
export { adminsubs_cancel1 as "adminSubs_cancel" }